exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.search-box{position:relative;border:1px solid #8b8b8b;width:195px;height:36px;margin:23px 10px 23px 23px;background:#303030;border-radius:2px}.search-box.adjust-bottom-margin{margin-bottom:4px}.search-box.locations-projects{margin-left:14px}.search-box .search-input{width:122px;height:34px;background:#303030;color:#8b8b8b;font-size:11px;margin-left:27px;font-family:Open Sans,sans-serif;font-weight:400;border:none;outline:none;border-radius:2px 0 0 2px}.search-box input::placeholder{font-family:Open Sans,sans-serif;font-weight:400;font-size:12px;color:#8b8b8b;font-style:normal}.search-box .search-icon{position:absolute;left:8px;top:12px;height:14px;width:14px;background-image:url(" + require("../../../assets/images/search-icon-grey.svg") + ");background-repeat:no-repeat}.search-box .filter-box{position:absolute;right:0;top:0;cursor:pointer;width:43px;height:36px;border-radius:0 2px 2px 0;background:#222}.search-box .filter-box .filter-icon{position:absolute;right:12px;top:9px;width:19px;height:19px;background-image:url(" + require("../../../assets/images/project-filter-icon.svg") + ");background-repeat:no-repeat}.search-box .filter-box .filter-applied{position:absolute;left:163px;top:4px;height:10px;width:10px;background-image:url(" + require("../../../assets/images/filter-dot-red.svg") + ")}.search-box .filter-box .filter-applied.less-right{left:24px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/ProjectsNav/ProjectSearchFilter/ProjectSearchFilter.scss
// module id = 1609
// module chunks = 0